import React from 'react';
import {StyleSheet} from 'react-native';
import ToggleSwitch from '../../../components/toggle/ToggleSwitch';
import IconTextItem from './IconTextItem';

export default function IconTextSwitchItem(props) {
  const {isOn, onToggle, balance} = props;
  return (
    <IconTextItem
      {...props}
      children={
        <ToggleSwitch
          isOn={isOn}
          onToggle={onToggle}
          style={styles.container}
          disabled={Number(balance) === 0}
        />
      }
    />
  );
}

const styles = StyleSheet.create({
  container: {
    marginHorizontal: 12,
  },
});
